import React, {createContext, useContext, useEffect, useState} from "react"
import {BACKEND_URL} from "../constants"

const ArticlesContext = createContext([])

export const useArticles = () => useContext(ArticlesContext)

export const ArticlesProvider = ({children}) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch(`${BACKEND_URL}/articles?limit=300`)
      .then(res => res.json())
      .then(data => {
        setData(data)
        setLoading(false)
      })
      .catch(err => {
        console.error("Błąd ładowania artykułów:", err)
        setLoading(false)
      })
  }, [])

  return (
    <ArticlesContext.Provider value={{data, loading}}>
      {children}
    </ArticlesContext.Provider>
  )
}
